const logActionType = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  PRINT: 'print',
};

export const logActionTypeList = [
  { label: logActionType.CREATE, value: logActionType.CREATE },
  { label: logActionType.UPDATE, value: logActionType.UPDATE },
  { label: logActionType.DELETE, value: logActionType.DELETE },
  { label: logActionType.PRINT, value: logActionType.PRINT },
];

export default logActionType;
